class ScannerHandler {
  private readonly onCodeRead: (eanCode: string) => void;
  private lastUpdateTime = 0;
  private scanned = "";

  constructor(onCodeRead: (code: string) => void) {
    this.onCodeRead = onCodeRead;
    this.handleKeyDown = this.handleKeyDown.bind(this);
  }

  private handleKeyDown(event: KeyboardEvent) {
    if (document.activeElement?.tagName.toLowerCase() === "input") return;
    if (event.key === "Shift") return;
    const withinTimeLimit = new Date().getTime() - this.lastUpdateTime < 50;
    if (withinTimeLimit && event.key === "Enter") {
      this.onCodeRead(this.scanned);
    } else if (withinTimeLimit) {
      this.scanned += event.key;
    } else {
      this.scanned = event.key;
    }
    this.lastUpdateTime = Date.now();
  }

  public start() {
    document.addEventListener("keydown", this.handleKeyDown);
  }

  public stop() {
    document.removeEventListener("keydown", this.handleKeyDown);
  }
}

export default ScannerHandler;
